import { render } from "./listDeprivedLiberty.vue?vue&type=template&id=b9a0fdf0"
import script from "./listDeprivedLiberty.vue?vue&type=script&lang=js"
export * from "./listDeprivedLiberty.vue?vue&type=script&lang=js"

import "./listDeprivedLiberty.vue?vue&type=style&index=0&id=b9a0fdf0&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__